// Utility to update meta tags for social sharing
export const updateMetaTags = (config) => {
  const {
    title = 'GuideSofia',
    description = 'Explore the world with GuideSofia - Your personal AI audio tour guide',
    image = 'https://www.guidesofia.com/wp-content/uploads/2025/05/Circle-logo.png',
    url = window.location.href,
  } = config;

  // Update basic meta tags
  updateMetaTag('title', title);
  updateMetaTag('description', description);

  // Update Open Graph tags
  updateMetaTag('og:title', title, 'property');
  updateMetaTag('og:description', description, 'property');
  updateMetaTag('og:image', image, 'property');
  updateMetaTag('og:url', url, 'property');

  // Update Twitter Card tags
  updateMetaTag('twitter:title', title, 'name');
  updateMetaTag('twitter:description', description, 'name');
  updateMetaTag('twitter:image', image, 'name');

  // Update document title
  document.title = title;
};

// Helper function to update or create meta tag
const updateMetaTag = (name, content, type = 'name') => {
  let tag = document.querySelector(`meta[${type}="${name}"]`);

  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(type, name);
    document.head.appendChild(tag);
  }

  tag.setAttribute('content', content);
};
